import { create } from 'zustand';
import type { OutboxEntity } from '@/types/models';

export interface SyncIssue {
  seq: number;
  entity: OutboxEntity;
  entity_id: string;
  error: string;
}

interface SyncState {
  online: boolean;
  syncing: boolean;
  pending: number;
  lastSyncAt: string | null;
  lastRowCount: number;
  error: string | null;
  issues: SyncIssue[];

  setOnline: (v: boolean) => void;
  setSyncing: (v: boolean) => void;
  setPending: (n: number) => void;
  setLastSync: (at: string, rows: number) => void;
  setError: (e: string | null) => void;
  addIssue: (i: SyncIssue) => void;
  clearIssue: (seq: number) => void;
  /** Replace the list from the outbox — the outbox is the truth and
   *  survives a reload; this store does not. */
  setIssues: (issues: SyncIssue[]) => void;
  /** The Sync issues panel, openable from the status chip on any screen. */
  issuesOpen: boolean;
  setIssuesOpen: (open: boolean) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  syncing: false,
  pending: 0,
  lastSyncAt: null,
  lastRowCount: 0,
  error: null,
  issues: [],

  setOnline: (online) => set({ online }),
  setSyncing: (syncing) => set({ syncing }),
  setPending: (pending) => set({ pending }),
  setLastSync: (lastSyncAt, lastRowCount) => set({ lastSyncAt, lastRowCount }),
  setError: (error) => set({ error }),
  addIssue: (issue) =>
    set((s) => (s.issues.some((i) => i.seq === issue.seq) ? s : { issues: [...s.issues, issue] })),
  clearIssue: (seq) => set((s) => ({ issues: s.issues.filter((i) => i.seq !== seq) })),
  setIssues: (issues) => set({ issues }),
  issuesOpen: false,
  setIssuesOpen: (issuesOpen) => set({ issuesOpen }),
}));
